export const ConvertToAssetTemplateCodeList = (assetTemplateCodeListRaw: any) => {
  const assetTemplateCodeList = [];

  if (assetTemplateCodeListRaw && assetTemplateCodeListRaw.length > 0) {
    for (const assetTemplateCodeRaw of assetTemplateCodeListRaw) {
      assetTemplateCodeList.push({
        id: assetTemplateCodeRaw.id,
        assetTemplateCode: assetTemplateCodeRaw.assetTemplateCode,
      });
    }
  }
  return assetTemplateCodeList;
};
